import { LayoutTemplate } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTemplates } from "@/lib/templates";

/** "From template": a list of the user's and shared templates to start a new chat from. */
export default function TemplateMenu() {
  const templates = useTemplates().data;
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  if (!templates?.length) return null;
  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm hover:bg-zinc-200/50 dark:hover:bg-zinc-800/60"
      >
        <LayoutTemplate size={18} />
        <span className="min-w-0 flex-1 truncate text-left">From template</span>
      </button>
      {open && (
        <ul className="absolute left-0 right-0 z-30 mt-1 max-h-72 overflow-y-auto rounded-xl border border-zinc-200 bg-white p-1 shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
          {templates.map((t) => (
            <li key={t.id}>
              <Link
                to={`/?template=${t.id}`}
                onClick={() => setOpen(false)}
                className="block rounded-lg px-2.5 py-1.5 text-sm hover:bg-zinc-100 dark:hover:bg-zinc-800"
                title={t.description || undefined}
              >
                <span className="block truncate">{t.name}</span>
                {t.description && <span className="block truncate text-xs text-zinc-500">{t.description}</span>}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
